import type { IconProps } from '../types/IconProps.ts';
export const CopyX: IconProps = {
    name: 'CopyX',
    children: [
        `<path d="M4 16a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2" />`,
        `<path d="M20 8H10a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2M12 12l6 6M12 18l6-6" />`,
    ]
};